import { getOrSetUniversal } from './-private.js';
const RuntimeConfig = getOrSetUniversal('WarpDriveRuntimeConfig', {
  debug: {}
});
function trySessionStorage() {
  // This works even when sessionStorage is not available.
  // See https://github.com/emberjs/data/issues/9784
  try {
    return globalThis.sessionStorage;
  } catch {
    return undefined;
  }
}
const storage = trySessionStorage();
const settings = storage?.getItem('WarpDriveRuntimeConfig');
if (settings) {
  Object.assign(RuntimeConfig, JSON.parse(settings));
}
function getRuntimeConfig() {
  return RuntimeConfig;
}

/**
 * Upserts the specified logging configuration into the runtime
 * config.
 *
 * globalThis.setWarpDriveLogging({ LOG_CACHE: true } });
 *
 */
function setLogging(config) {
  Object.assign(RuntimeConfig.debug, config);
  storage?.setItem('WarpDriveRuntimeConfig', JSON.stringify(RuntimeConfig));
}
export { getRuntimeConfig, setLogging };